module.exports = __webpack_public_path__ + "static/product-box-8cc505ae3435b7b8135d2254b81fbf20.png";